export const actions = {
    GET_MY_GROUP: 'GET_MY_GROUP',
    SET_MY_GROUP: 'SET_MY_GROUP',
    FORUM_GET_CONVERSION: 'FORUM_GET_CONVERSATION',
    FORUM_SET_CONVERSION: 'FORUM_SET_CONVERSATION',
    FORUM_ADD: 'FORUM_ADD',
    FORUM_GET_FORUMMESSAGE: 'FORUM_GET_FORUMMESSAGE',
    FORUM_SET_FORUMMESSAGE: 'FORUM_SET_FORUMMESSAGE',
    FORUM_GET_THREADBYID: 'FORUM_GET_THREADBYID',
    FORUM_SET_THREADBYID: 'FORUM_SET_THREADBYID',
    FORUM_SEND_MESSAGE: 'FORUM_SEND_MESSAGE',
    FORUM_DELETE: 'FORUM_DELETE',
    FORUM_SEND_ANSWER: 'FORUM_SEND_ANSWER',
    FORUM_DELETE_ANSWER: 'FORUM_DELETE_ANSWER',

    ADD_FORUM_ACTIVITY_GET: 'ADD_FORUM_GET_ACTIVITY',
    ADD_FORUM_ACTIVITY_SET: 'ADD_FORUM_SET_ACTIVITY',

    GET_FORUM_DATA: 'GET_FORUM_DATA',
    SET_FORUM_DATA: 'SET_FORUM_DATA',

    SET_FORUM_DATA_DEFAULT: 'SET_FORUM_DATA_DEFAULT',

    FORUM_SET_ANSWERS: 'FORUM_SET_ANSWERS',
    GET_MESSAGE_DATA: 'GET_MESSAGE_DATA',
    SET_MESSAGE_DATA: 'SET_MESSAGE_DATA',
    SET_DEFAULT_MESSAGE_DATA: 'SET_DEFAULT_MESSAGE_DATA',

    FORUM_RATING_MESSAGE: 'FORUM_RATING_MESSAGE',
    UPDATE_FORUM_MESSAGE: 'UPDATE_FORUM_MESSAGE',
    SET_MESSAGE_UPDATE_DATA: 'SET_MESSAGE_UPDATE_DATA'
};
